import en from './en.json';
import id from './id.json';
import fr from './fr.json';
import enId from './en-id.json';
import enIn from './en-in.json';
import enMy from './en-my.json';
import enPh from './en-ph.json';
import enTh from './en-th.json';
import esAr from './es-ar.json';
import esCl from './es-CL.json';
import esCo from './es-CO.json';
import esEs from './es-ES.json';
import esMx from './es-MX.json';
import msMy from './ms-my.json';
import pl from './pl.json';
import ptBr from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';
export default {
  en: en,
  // 英语
  'en-my': enMy,
  'en-id': enId,
  'en-in': enIn,
  'en-ph': enPh,
  'en-th': enTh,
  'es-ar': esAr,
  'es-CL': esCl,
  'es-CO': esCo,
  'es-ES': esEs,
  'es-MX': esMx,
  fr: fr,
  id: id,
  'ms-my': msMy,
  pl: pl,
  'pt-BR': ptBr,
  th: th,
  vi: vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant
};